import React from "react";
import { thisBaseURL } from "../../utils/helper.js";
import FoodDefenseIncidents from "./FoodDefenseIncidents";

function FoodSafetyDefense({countryAnswers}){
	let defaultCountry = countryAnswers.answerKeyValues["country_code"];
	let foodBorneIllnessSourceRef = countryAnswers.answerKeyValues['estimated_annual_foodborne_illness_cases_per_100_000__sources'];
	let foodBorneIllnessNotes = countryAnswers.answerKeyValues['estimated_annual_foodborne_illness_cases_per_100_000__notes'];
	let foodBorneIllnessYear = countryAnswers.answerKeyValues['estimated_annual_foodborne_illness_cases_per_100_000__year'];
	
	let codexSourceRef = countryAnswers.answerKeyValues['codex_membership_sources'];
	let codexYear = countryAnswers.answerKeyValues['codex_membership_year'];
	let codexNotes = countryAnswers.answerKeyValues['codex_membership_notes'];
	
	let foodRegulatorySourceRef = countryAnswers.answerKeyValues['primary_food_safety_regulatory_and_enforcement_agency_s__sources'];
	let foodRegulatoryYear = countryAnswers.answerKeyValues['primary_food_safety_regulatory_and_enforcement_agency_s__year'];
	let foodRegulatoryNotes = countryAnswers.answerKeyValues['primary_food_safety_regulatory_and_enforcement_agency_s__notes'];
	
	let foodDefenceSourceRef = countryAnswers.answerKeyValues['food_defense_program_sources'];
	let foodDefenceYear = countryAnswers.answerKeyValues['food_defense_program_year'];
	let foodDefenceNotes = countryAnswers.answerKeyValues['food_defense_program_notes'];
	
	let emaIncidentsSourceRef = countryAnswers.answerKeyValues['ema_incidents_sources'];
	let emaIncidentsYear = countryAnswers.answerKeyValues['ema_incidents_year'];
	let emaIncidentsNotes = countryAnswers.answerKeyValues['ema_incidents_notes'];
	let emaIncidents = countryAnswers.answerKeyValues['ema_incidents'];
	let emaIncidentArr = [];
	if (emaIncidents) {
		try {
			emaIncidentArr = JSON.parse(emaIncidents);
		} catch (err) {
			console.log("FoodSafetyDefense :emaIncidents : "+ err);
		}
	}
	
	return(<div className="question-grouping" id="food_safety_defense">
				<h2>Food Safety &amp; Defense</h2>
				<h3>
					Estimated Annual Foodborne Illness Cases (per 100,000)
					{foodBorneIllnessYear ? 
					<small>&nbsp;({foodBorneIllnessYear})</small>
					: ""}
					{foodBorneIllnessSourceRef && foodBorneIllnessSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+foodBorneIllnessSourceRef}>{foodBorneIllnessSourceRef}</a></small>
					: ""}
				</h3>
				<p>{countryAnswers.answerKeyValues['estimated_annual_foodborne_illness_cases_per_100_000_']}</p>
				{foodBorneIllnessNotes ? 
				<p className="notes-info" style={{marginTop:"auto"}} >
					<em>{foodBorneIllnessNotes}</em>
				</p>
				: ""}
				
				<h3>
					CODEX membership
					{codexYear ? 
					<small>&nbsp;({codexYear})</small>
					: ""}
					{codexSourceRef && codexSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+codexSourceRef}>{codexSourceRef}</a></small>
					: ""}
				</h3>
				<p>{countryAnswers.answerKeyValues['codex_membership']}</p>
				{codexNotes ? 
				<p className="notes-info" style={{marginTop:"auto"}} >
					<em>{codexNotes}</em>
				</p>
				: ""}
				
				<h3>
					Primary food safety regulatory and enforcement agency(s)
					{foodRegulatoryYear ? 
					<small>&nbsp;({foodRegulatoryYear})</small>
					: ""}
					{foodRegulatorySourceRef && foodRegulatorySourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+foodRegulatorySourceRef}>{foodRegulatorySourceRef}</a></small>
					: ""}
				</h3>
				<p>{countryAnswers.answerKeyValues['primary_food_safety_regulatory_and_enforcement_agency_s_']}</p>
				{foodRegulatoryNotes ? 
				<p className="notes-info" style={{marginTop:"auto"}} >
					<em>{foodRegulatoryNotes}</em>
				</p>
				: ""}
				
				<h3>
					Food defense program
					{foodDefenceYear ? 
					<small>&nbsp;({foodDefenceYear})</small>
					: ""}
					{foodDefenceSourceRef && foodDefenceSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+foodDefenceSourceRef}>{foodDefenceSourceRef}</a></small>
					: ""}
				</h3>
				<p>{countryAnswers.answerKeyValues['food_defense_program']}</p>
				{foodDefenceNotes ? 
				<p className="notes-info" style={{marginTop:"auto"}} >
					<em>{foodDefenceNotes}</em>
				</p>
				: ""}
	
	             <h3>
					Food Defense Incidents
					{emaIncidentsYear ? 
					<small>&nbsp;({emaIncidentsYear})</small>
					: ""}
					{emaIncidentsSourceRef && emaIncidentsSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+emaIncidentsSourceRef}>{emaIncidentsSourceRef}</a></small>
					: ""}
				</h3>
				{emaIncidentArr && emaIncidentArr.length >0 ? <table style={{width:"100%", float:"left", marginBottom:"10px"}}>
					<thead></thead>
						<FoodDefenseIncidents emaIncidentArr={{emaIncidentArr}} />
				</table>
				: "" }
				{emaIncidentsNotes ? 
				<p className="notes-info" style={{marginTop:"auto"}} >
					<em>{emaIncidentsNotes}</em>
				</p>
				: ""}
				<p></p>
			</div>);
}
export default FoodSafetyDefense;